<template>
  <div class="profit">
    <div class="profit-top">
      <div class="title">
        <div class="title-text">可用积分</div>
        <div class="title-number">{{userinfo.points}}</div>
      </div>
      <div class="rule-button" @click="$router.push('/integralinterest')"></div>
    </div>
    <div class="list">
      <!-- <div class="list-item" v-if="evaluation.show === 1">
        <div class="iocn-1"></div>
        <div class="describe">
          <div class="describe-top">香港优才计划评测</div>
          <div class="describe-bottom">
            完成评测可换得
            <span>30</span>积分
          </div>
        </div>
        <div class="right">
          <div
            class="button"
            :class="{'eval' : evaluation.status === 1}"
            @click="evaluating"
          >{{evaluation.status === 1 ? '已完成' : '立即参与'}}</div>
        </div>
      </div> -->
      <!-- <div class="list-item">
        <div class="iocn-2"></div>
        <div class="describe">
          <div class="describe-top">推荐好友注册</div>
          <div class="describe-bottom">
            推荐<span>1</span>个有效用户注册可获<span>{{setting.recommend_integral}}</span>积分
          </div>
        </div>
        <div class="right">
          <div class="button" @click="contract">{{register.count <= 0 ? '立即参与' : '继续完成'}}</div>
          <p v-if="register.count > 0">已完成：{{register.count}}</p>
        </div>
      </div> -->
      <div class="list-item">
        <div class="iocn-3"></div>
        <div class="describe">
          <div class="describe-top">推荐好友签约</div>
          <div class="describe-bottom">
            邀请好友签约最高获得
            <span>{{setting.recommend_max_integral}}</span>积分
          </div>
        </div>
        <div class="right">
          <div class="button" @click="contract">{{sign.count <= 0 ? '立即参与' : '继续完成'}}</div>
          <p v-if="sign.count > 0">已完成：{{sign.count}}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getTaskInfo, getIntegralSetting } from "../../../api/api-config";
export default {
  props: {},
  data() {
    return {
      evaluation: {},
      register: {},
      sign: {},
      userinfo: {},
      setting: {}
    };
  },
  computed: {},
  created() {
    let userinfo = JSON.parse(this.$Cookie.get("userinfo"));
    if (userinfo) {
      this.userinfo = userinfo;
    }
    this.getTaskInfo();
    this.getIntegralSetting();
  },
  mounted() {},
  watch: {},
  methods: {
    evaluating($event) {
      // 测试评测页
      //  "http://test.m.web.galaxy-immi.com/obscure/assessment/2.html?pla=jfsc&spreadword=jfsc"
      window.open(
        "http://m.galaxy-immi.com//obscure/assessment/2.html?pla=jfsc&spreadword=jfsc"
      );
    },
    inviteLogin() {
      // 用原生的方式解决，路由跳转，ios长按图片不显示 发送好友和识别二维码
      window.location = "/inviteLogin";
    },
    contract() {
      window.location = "/recommend";
    },
    async getTaskInfo() {
      this.$indicator.open();
      const res = await getTaskInfo();
      const data = res.data;
      if (data.code === 200) {
        const taskData = data.data;
        this.evaluation = taskData.evaluation;
        this.register = taskData.register;
        this.sign = taskData.sign;
      }
      this.$indicator.close();
    },
    async getIntegralSetting() {
      const res = await getIntegralSetting();
      const data = res.data;
      if (data.code === 200) {
        this.setting = data.data;
      }
    }
  },
  components: {}
};
</script>

<style scoped lang="scss">
.profit {
}
.profit-top {
  width: 100%;
  height: rem(260);
  background: url("./images/earn_points.png") no-repeat;
  background-size: 100% rem(260);
  position: relative;
  text-align: center;
  .title {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    .title-text {
      font-size: rem(34);
      color: #fff;
    }
    .title-number {
      font-size: rem(90);
      color: #fff;
      font-weight: 800;
    }
  }
  .rule-button {
    width: rem(160);
    height: rem(54);
    background: url("./images/rule_description.png") no-repeat;
    background-size: rem(160) rem(54);
    position: absolute;
    top: rem(33);
    right: 0;
  }
}
.list {
  margin: rem(40) rem(30) 0 rem(30);
  .list-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid rgba(237, 237, 237, 1);
    padding-bottom: rem(40);
    &:nth-of-type(2) {
      margin-top: rem(38);
    }
    &:nth-of-type(3) {
      margin-top: rem(38);
    }
    .iocn-1,
    .iocn-2,
    .iocn-3 {
      width: rem(102);
      height: rem(102);
    }
    .iocn-1 {
      background: url("./images/evaluation_icon.png") no-repeat;
      background-size: rem(102) rem(102);
    }
    .iocn-2 {
      background: url("./images/registered_icon.png") no-repeat;
      background-size: rem(102) rem(102);
    }
    .iocn-3 {
      background: url("./images/Signing_icon.png") no-repeat;
      background-size: rem(102) rem(102);
    }
    .describe {
      flex: 0 0 rem(383);
      .describe-top {
        font-size: rem(34);
        font-weight: 800;
        color: #333;
        margin-bottom: rem(10);
      }
      .describe-bottom {
        font-size: rem(26);
        color: #999;
        & > span {
          font-size: rem(26);
          color: #ff5d00;
          font-weight: 600;
        }
      }
    }
    .right {
      .button {
        width: rem(168);
        height: rem(64);
        background: #3386ff;
        color: #fff;
        font-size: rem(26);
        text-align: center;
        line-height: rem(64);
        border-radius: rem(32);
      }
      .eval {
        pointer-events: none;
        background: #c8c4c4;
      }
      & > p {
        font-size: rem(22);
        color: #999;
        text-align: center;
        padding-top: rem(20);
      }
    }
  }
}
</style>
